// extracted by css-extract-rspack-plugin
export default {"root":"IIfWqD"};